var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 62,
    viewBox: "0 0 108 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4866 1L41.6978 16.235C44.706 19.2459 46.7551 23.0828 47.5858 27.2603C48.4166 31.4378 47.9916 35.7682 46.3647 39.7037C44.7379 43.6393 41.9822 47.0032 38.4462 49.37C34.9103 51.7367 30.7529 53 26.5 53C22.2471 53 18.0897 51.7367 14.5538 49.37C11.0178 47.0032 8.26212 43.6393 6.63525 39.7037C5.00838 35.7682 4.58343 31.4378 5.41416 27.2603C6.24488 23.0828 8.29396 19.2459 11.3022 16.235L26.4866 1Z",
    fill: "#F6655F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4866 1L41.6978 16.235C44.706 19.2459 46.7551 23.0828 47.5858 27.2603C48.4166 31.4378 47.9916 35.7682 46.3647 39.7037C44.7379 43.6393 41.9822 47.0032 38.4462 49.37C34.9103 51.7367 30.7529 53 26.5 53C22.2471 53 18.0897 51.7367 14.5538 49.37C11.0178 47.0032 8.26212 43.6393 6.63525 39.7037C5.00838 35.7682 4.58343 31.4378 5.41416 27.2603C6.24488 23.0828 8.29396 19.2459 11.3022 16.235L26.4866 1Z",
    stroke: "#FBFBFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.432 37L67.784 29.02H64.704V37H62.156V17.484H68.456C69.9307 17.484 71.172 17.736 72.18 18.24C73.2067 18.744 73.972 19.4253 74.476 20.284C74.98 21.1427 75.232 22.1227 75.232 23.224C75.232 24.568 74.84 25.7533 74.056 26.78C73.2907 27.8067 72.1333 28.488 70.584 28.824L75.484 37H72.432ZM64.704 26.976H68.456C69.8373 26.976 70.8733 26.64 71.564 25.968C72.2547 25.2773 72.6 24.3627 72.6 23.224C72.6 22.0667 72.2547 21.1707 71.564 20.536C70.892 19.9013 69.856 19.584 68.456 19.584H64.704V26.976ZM81.7392 17.484V37H79.1912V17.484H81.7392ZM95.8538 26.948C96.5631 27.06 97.2071 27.3493 97.7858 27.816C98.3831 28.2827 98.8498 28.8613 99.1858 29.552C99.5404 30.2427 99.7178 30.98 99.7178 31.764C99.7178 32.7533 99.4658 33.6493 98.9618 34.452C98.4578 35.236 97.7204 35.8613 96.7498 36.328C95.7978 36.776 94.6684 37 93.3618 37H86.0818V17.484H93.0818C94.4071 17.484 95.5364 17.708 96.4698 18.156C97.4031 18.5853 98.1031 19.1733 98.5698 19.92C99.0364 20.6667 99.2698 21.5067 99.2698 22.44C99.2698 23.5973 98.9524 24.5587 98.3178 25.324C97.7018 26.0707 96.8804 26.612 95.8538 26.948ZM88.6298 25.912H92.9138C94.1084 25.912 95.0324 25.632 95.6858 25.072C96.3391 24.512 96.6658 23.7373 96.6658 22.748C96.6658 21.7587 96.3391 20.984 95.6858 20.424C95.0324 19.864 94.0898 19.584 92.8578 19.584H88.6298V25.912ZM93.1378 34.9C94.4071 34.9 95.3964 34.6013 96.1058 34.004C96.8151 33.4067 97.1698 32.576 97.1698 31.512C97.1698 30.4293 96.7964 29.58 96.0498 28.964C95.3031 28.3293 94.3044 28.012 93.0538 28.012H88.6298V34.9H93.1378ZM105.802 17.484V37H103.254V17.484H105.802Z",
    fill: "#F6655F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_6",
    x: 0,
    y: 0,
    width: 53,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_6",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f24a9a03fd45e97e0dc37d2cd80e8b5.svg";
export { ForwardRef as ReactComponent };